import { useRecoilValue } from 'recoil'
import { IUnit } from '../../parameters.types'
import parametersSelectors from '../../parameters.selectors'

interface IProps {
  unitId: IUnit['id']
}

const ParameterUnitSpan = (props: IProps) => {
  const unitsMap = useRecoilValue(parametersSelectors.getUnitsMap)

  if (!unitsMap[props.unitId]) return null
  return <span className="text-nm">{unitsMap[props.unitId].nameRu}</span>
}

export default ParameterUnitSpan
